<template>
  <div>

    <!-- <footer>
      <div class="container-fluid">
        <div class="footer-content">
            <div class="bg-title">GAEE</div>
            <div class="footer-body">
              <div class="footer-links">
                <router-link class="footer-link"
                  v-if="(header[0]) ? header[0].status : false"
                  to="/accreditations">Accreditation</router-link>

                <router-link class="footer-link"
                  v-if="(header[8]) ? header[8].status : false"
                  to="/our-certificates">Certification</router-link>

                <router-link class="footer-link"
                  v-if="(header[3]) ? header[3].status : false"
                  to="/about">About</router-link>

                <router-link class="footer-link"
                  v-if="(header[1]) ? header[1].status : false"
                  to="/programs">Programs</router-link>

                <router-link class="footer-link"
                  v-if="(header[2]) ? header[2].status : false"
                  to="/memberships">Membership</router-link>

                <router-link class="footer-link"
                  v-if="(header[4]) ? header[4].status : false"
                  to="/contact">Contact us</router-link>

                <router-link class="footer-link"
                  v-if="(header[7]) ? header[7].status : false"
                  to="/online-trainings">Online Training</router-link>

                <router-link class="footer-link"
                  v-if="(header[6]) ? header[6].status : false"
                  to="/events">Events &amp; Conferences</router-link>

                <router-link v-for="(pg, idx) in pages" :key="idx"
                    :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                    class="footer-link"
                    :class="(pg.has_footer) ? '' : 'hidden' ">
                    {{ pg.title }}</router-link>
              </div>
              <div class="footer-socialmedia">
                <div class="footer-sm-con">
                  <div class="socialmedia mb-3 justify-content-between d-flex align-items-center">
                    <div class="follow-text mr-3">Follow us</div>
                    <div class="footer-socialmedia">

                      <a v-for="(social, index) in rows" 
                        class="facebook-icon social-icon" 
                        :href="social.provider_url"
                        target="_blank"
                        :key="index">
                        <i v-if="social.provider.toLowerCase() == 'facebook'"
                          class="fab fa-facebook-f"></i>
                        <i v-if="social.provider.toLowerCase() == 'youtube'"
                          class="fab fa-youtube"></i>
                        <i v-if="social.provider.toLowerCase() == 'linkedin'"
                          class="fab fa-linkedin-in"></i>
                        <i v-if="social.provider.toLowerCase() == 'twitter'"
                          class="fab fa-twitter"></i>
                      </a>
                      
                    </div>
                  </div>
                  <div class="text">Global Association of Electrical Engineers </div>
                </div>
              </div>
              <div class="us-footer-contact">
                <div class="title mb-4">News</div>
                <div class="contact-input d-flex">
                  <input type="search" placeholder="Your mail here" />
                  <button class="subscribe-btn">
                    <div class="d-flex align-items-center">Subscribe <span class="icon-back"></span></div>
                  </button>
                </div>
              </div>
            </div>
            <div class="footer-bottom">
              <div class="fb-content d-flex flex-wrap align-items-center">
                <div class="text">2021 All Rights Reserved © GAEE <router-link class="ml-2 privacy-link"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link></div>
                <div class="socialmedia d-flex align-items-center">
                  <div class="follow-text mr-3">Follow us</div>
                  <div class="footer-socialmedia">

                    <a v-for="(social, index) in rows" 
                      class="facebook-icon social-icon" 
                      :href="social.provider_url"
                      target="_blank"
                      :key="index">
                      <i v-if="social.provider.toLowerCase() == 'facebook'"
                        class="fab fa-facebook-f"></i>
                      <i v-if="social.provider.toLowerCase() == 'youtube'"
                        class="fab fa-youtube"></i>
                      <i v-if="social.provider.toLowerCase() == 'linkedin'"
                        class="fab fa-linkedin-in"></i>
                      <i v-if="social.provider.toLowerCase() == 'twitter'"
                        class="fab fa-twitter"></i>
                    </a>
                    
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </footer> -->


    <footer>
      <div class="container-fluid">
        <div class="footer-top">
          <div class="footer-lt">
            <div class="bg-title">GCLA</div>
            <div class="footer-links">
              <router-link class="footer-link"
                v-if="(header[0]) ? header[0].status : false"
                to="/accreditations">Accreditation</router-link>

              <router-link class="footer-link"
                v-if="(header[8]) ? header[8].status : false"
                to="/our-certificates">Certification</router-link>

              <router-link class="footer-link"
                v-if="(header[3]) ? header[3].status : false"
                to="/about">About</router-link>

              <router-link class="footer-link"
                v-if="(header[1]) ? header[1].status : false"
                to="/programs">Programs</router-link>

              <router-link class="footer-link"
                v-if="(header[2]) ? header[2].status : false"
                to="/memberships">Membership</router-link>

              <router-link class="footer-link"
                v-if="(header[4]) ? header[4].status : false"
                to="/contact">Contact us</router-link>

              <router-link class="footer-link"
                v-if="(header[7]) ? header[7].status : false"
                to="/online-trainings">Online Training</router-link>

              <router-link class="footer-link"
                v-if="(header[6]) ? header[6].status : false"
                to="/events">Events &amp; Conferences</router-link>

              <router-link v-for="(pg, idx) in pages" :key="idx"
                  :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                  class="footer-link"
                  :class="(pg.has_footer) ? '' : 'hidden' ">
                  {{ pg.title }}</router-link>
            </div>
          </div>
          <div class="footer-contact">
            <div class="footer-logo mb-4 d-flex align-items-center">
              <img :src="logo.logo" class="img-fluid" alt="" />
              <div class="footer-logo-title pl-2 white-color">Global Council for Law,<br /> Arbitration and Intellectual<br /> Property </div>
            </div>
            <div class="footer-contact">
              <div class="fc-head white-color d-flex align-items-center justify-content-between">
                <div class="bg-title white-color">News</div>
                <div class="text white-color">Subscribe to our latest news</div>
              </div>

              <div class="contact-group">
                <input v-model="email" type="text" placeholder="Your mail here " />
                <button @click="newsletter" class="subscribe-btn">
                  <div class="d-flex align-items-center">Subscribe <span class="icon-back icon"></span></div>
                </button>
              </div>
              <div v-if="success" style="color: #080" class="alert-msg mt-2">email sent successfully.</div>
              <div v-if="error" style="color: #f00" class="alert-msg mt-2">this email not valid.</div>
            </div>
          </div>
        </div>

        <div class="footer-bottom d-flex flex-wrap align-items-center justify-content-between">
          <div class="text white-color">2021 All Rights Reserved © GCLA <router-link class="privacy-btn ml-2" to="/privacy">Privacy Policy</router-link></div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">

              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
footer {
  background: #001157;
}
.footer-top {
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
.footer-bottom { 
  border-top: 1px solid #fff;
  padding: 16px 0;
}
.privacy-btn {
  text-decoration: underline !important;
  cursor: pointer;
  color: #fff;
}
.privacy-btn:hover {
  text-decoration: none !important;
}
.footer-socialmedia {
  line-height: 1;
}
.follow-text {
  font-size: 17px;
}
.socialmedia,
.socialmedia a,
.socialmedia div {
  color: #fff;
}
.socialmedia a {
  margin-left: 19px;
  font-size: 17px;
}
.socialmedia a:hover {
  color: #ddd;
}
.footer-logo-title {
  font-size: 23px;
  line-height: 1.2;
}
.footer-logo img {
  width: 115px;
}
.bg-title {
  font-size: 30px;
}
.fc-head {
  border-top: 1px solid #fff;
  padding-top: 15px;
  margin-bottom: 15px;
}

.footer-body {
  padding: 30px 0 20px;
  display: flex;
  justify-content: space-between;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
}
.footer-link {
  color: #437AA3;
  width: 30%;
  margin-bottom: 16px;
  font-size: 19px;
}
.footer-link:hover {
  color: #fff;
}
.title {
  color: #437AA3;
  line-height: 1;
}
.subscribe-btn {
  background: #AF8916;
  border: 1px solid #fff;
  color: #fff;
  padding: 5px 18px
}
.subscribe-btn:hover {
  background: #a78314;
}
.subscribe-btn:active {
  opacity: 0.6;
}
.subscribe-btn > div {
  color: #fff;
}
.subscribe-btn .icon-back:before {
  color: #fff;
  font-weight: bold;
}
.contact-group {
  display: flex;
}
.contact-group input {
  background: #fff !important;
  padding: 5px 15px;
  min-width: 290px;
  width: calc(100% - 128px);
  max-width: 100%;
}
.footer-lt .bg-title {
  color: #D5B34F;
  font-size: 55px;
  margin-bottom: 17px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) { 

}

@media (max-width: 767.98px) { 
  .footer-body {
    display: block;
  }
  .contact-group input {
    min-width: auto;
    border-radius: 0 !important;
  }
  .footer-link {
    width: 50%;
  }
  /* .footer-links {
    margin-bottom: 10px;
  } */
  .us-footer-contact {
    margin-bottom: 10px;
  }
  .socialmedia {
    justify-content: flex-start !important;
  }
  .footer-logo-title {
    font-size: 18px;
    padding-top: 7px
  }
  .footer-logo img {
    width: 90px;
  }
  .footer-top {
    flex-wrap: wrap;
  }
  .footer-contact {
    width: 100%;
    max-width: 450px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) { 

 }

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) { 
  .footer-link {
    width: 50%;
  }
  .footer-top {
    flex-wrap: wrap;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) { 
  .footer-top {
    flex-wrap: wrap;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 

 }
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      logo: [],
      pages: [],
      email: "",
      error: false,
      success: false
    };
  },
  created() {

      axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
        this.logo = res.data.logo;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
      
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          this.success = false;
        });
    }
  },
};
</script>
